// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Payment-root-khJpD {
  padding-left: 24px;
  padding-right: 24px;
}

.Payment-container-W6mQ1 {
  margin: 5px auto;
  padding: 0 0 40px;
  margin-top: 30px;
  max-width: var(--max-content-width);
}

@media screen and (max-width:991px) {
  .Payment-container-W6mQ1 {
    margin-top: 100px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/payment/Payment.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".root {\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.container {\n  margin: 5px auto;\n  padding: 0 0 40px;\n  margin-top: 30px;\n  max-width: var(--max-content-width);\n}\n\n@media screen and (max-width:991px) {\n  .container {\n    margin-top: 100px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Payment-root-khJpD`,
	"container": `Payment-container-W6mQ1`
};
module.exports = ___CSS_LOADER_EXPORT___;
